import React from 'react';

const createIcon = (children) => (props = {}) => (
  <svg
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    {children}
  </svg>
);

const icons = {
  pipeline: createIcon(
    <>
      <rect x="6" y="10" width="36" height="8" rx="4" />
      <rect x="6" y="30" width="36" height="8" rx="4" />
      <path d="M12 18v12" />
      <path d="M24 18v12" />
      <path d="M36 18v12" />
    </>
  ),
  infrastructure: createIcon(
    <>
      <rect x="12" y="10" width="24" height="28" rx="4" />
      <path d="M12 22h24" />
      <path d="M20 16h8" />
      <path d="M20 28h8" />
      <path d="M20 34h8" />
    </>
  ),
  monitor: createIcon(
    <>
      <rect x="8" y="10" width="32" height="24" rx="4" />
      <path d="M20 40h8" />
      <path d="M24 34v6" />
      <path d="M14 22h4l3 4 5-8 3 4h5" />
    </>
  ),
  container: createIcon(
    <>
      <rect x="9" y="9" width="30" height="30" rx="6" />
      <path d="M24 9v30" />
      <path d="M9 24h30" />
    </>
  ),
  shield: createIcon(
    <path d="M24 6l14 6v10c0 10-7 18-14 20-7-2-14-10-14-20V12z" />
  ),
  performance: createIcon(
    <>
      <path d="M12 34a12 12 0 1124 0" />
      <path d="M24 22l6 6" />
      <path d="M24 38v4" />
      <path d="M16 38h16" />
    </>
  ),
  assessment: createIcon(
    <>
      <rect x="14" y="8" width="20" height="32" rx="4" />
      <path d="M18 14h12" />
      <path d="M18 22h12" />
      <path d="M18 30h8" />
      <path d="M20 8l2-4h4l2 4" />
    </>
  ),
  toolkit: createIcon(
    <>
      <rect x="8" y="18" width="32" height="18" rx="4" />
      <path d="M16 18v-4a4 4 0 014-4h8a4 4 0 014 4v4" />
      <path d="M18 28l4-4 4 4" />
      <path d="M24 28v6" />
    </>
  ),
  automation: createIcon(
    <>
      <circle cx="24" cy="24" r="10" />
      <path d="M24 14V6" />
      <path d="M24 42v-8" />
      <path d="M14 24H6" />
      <path d="M42 24h-8" />
      <path d="M31 31l5 5" />
      <path d="M12 12l5 5" />
    </>
  ),
  insight: createIcon(
    <>
      <path d="M24 10a10 10 0 00-6 18l-2 6h16l-2-6a10 10 0 00-6-18z" />
      <path d="M20 40h8" />
      <path d="M22 44h4" />
    </>
  ),
  cloudUpload: createIcon(
    <>
      <path d="M18 36H14a8 8 0 010-16h1a10 10 0 1119 4h2a7 7 0 010 14h-6" />
      <path d="M24 32V20" />
      <path d="M20 24l4-4 4 4" />
    </>
  ),
  scaling: createIcon(
    <>
      <rect x="10" y="26" width="8" height="12" rx="2" />
      <rect x="20" y="20" width="8" height="18" rx="2" />
      <rect x="30" y="14" width="8" height="24" rx="2" />
      <path d="M18 14l6-6 6 6" />
      <path d="M24 8v12" />
    </>
  ),
  savings: createIcon(
    <>
      <path d="M12 24a12 12 0 0124 0v10H12z" />
      <path d="M12 28H8v6h4" />
      <path d="M36 28h4v6h-4" />
      <path d="M20 24h8" />
      <path d="M24 20v8" />
    </>
  ),
  recovery: createIcon(
    <>
      <circle cx="24" cy="24" r="14" />
      <path d="M24 14v20" />
      <path d="M14 24h20" />
    </>
  ),
  multiCloud: createIcon(
    <>
      <path d="M18 32H14a6 6 0 010-12h1a8 8 0 1114 3" />
      <path d="M30 36h4a6 6 0 100-12h-1a8 8 0 10-14-3" />
    </>
  ),
  architecture: createIcon(
    <>
      <rect x="10" y="12" width="28" height="24" rx="4" />
      <path d="M10 22h28" />
      <path d="M18 32h12" />
      <path d="M24 6v6" />
    </>
  ),
  roadmap: createIcon(
    <>
      <path d="M12 10h12l4 6h8" />
      <path d="M12 24h24" />
      <path d="M12 38h12l4-6h8" />
      <circle cx="24" cy="24" r="3" />
    </>
  ),
  analytics: createIcon(
    <>
      <rect x="8" y="12" width="32" height="24" rx="4" />
      <path d="M16 28l4-6 5 4 5-8" />
      <circle cx="18" cy="28" r="1" fill="currentColor" stroke="none" />
      <circle cx="25" cy="26" r="1" fill="currentColor" stroke="none" />
      <circle cx="30" cy="18" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  forecast: createIcon(
    <>
      <path d="M12 34a12 12 0 1124 0v4H12z" />
      <path d="M24 18v10" />
      <path d="M20 26l4 4 4-4" />
    </>
  ),
  brain: createIcon(
    <>
      <path d="M20 10a6 6 0 00-6 6v2a6 6 0 000 12v6a4 4 0 008 0V10z" />
      <path d="M28 10a6 6 0 016 6v2a6 6 0 010 12v6a4 4 0 01-8 0V10z" />
    </>
  ),
  dashboard: createIcon(
    <>
      <circle cx="24" cy="24" r="14" />
      <path d="M24 24l8-4" />
      <path d="M16 30h16" />
    </>
  ),
  target: createIcon(
    <>
      <circle cx="24" cy="24" r="14" />
      <circle cx="24" cy="24" r="7" />
      <circle cx="24" cy="24" r="2" fill="currentColor" stroke="none" />
    </>
  ),
  search: createIcon(
    <>
      <circle cx="21" cy="21" r="11" />
      <path d="M29 29l10 10" />
    </>
  ),
  realtime: createIcon(
    <>
      <rect x="8" y="12" width="32" height="24" rx="4" />
      <path d="M16 30l4-8 6 12 4-8" />
    </>
  ),
  dataStack: createIcon(
    <>
      <ellipse cx="24" cy="12" rx="14" ry="6" />
      <path d="M10 12v12c0 3.3 6.3 6 14 6s14-2.7 14-6V12" />
      <path d="M10 24v12c0 3.3 6.3 6 14 6s14-2.7 14-6V24" />
    </>
  ),
  integration: createIcon(
    <>
      <circle cx="12" cy="24" r="4" />
      <circle cx="24" cy="12" r="4" />
      <circle cx="36" cy="24" r="4" />
      <circle cx="24" cy="36" r="4" />
      <path d="M15 21l6-6" />
      <path d="M27 15l6 6" />
      <path d="M15 27l6 6" />
      <path d="M27 33l6-6" />
    </>
  ),
  api: createIcon(
    <>
      <path d="M10 18l8-8" />
      <path d="M10 30l8 8" />
      <path d="M38 18l-8-8" />
      <path d="M38 30l-8 8" />
      <rect x="18" y="18" width="12" height="12" rx="4" />
    </>
  ),
  governance: createIcon(
    <>
      <path d="M24 6l14 6v10c0 10-7 18-14 20-7-2-14-10-14-20V12z" />
      <path d="M18 24l4 4 8-8" />
    </>
  ),
  rocket: createIcon(
    <>
      <path d="M24 4c8 4 12 12 12 20 0 8-4 16-12 20-8-4-12-12-12-20 0-8 4-16 12-20z" />
      <path d="M18 26l-6 6" />
      <path d="M30 26l6 6" />
      <path d="M24 18a4 4 0 110 8 4 4 0 010-8z" />
      <path d="M24 28v12" />
    </>
  ),
  people: createIcon(
    <>
      <circle cx="18" cy="20" r="6" />
      <circle cx="30" cy="20" r="6" />
      <path d="M10 38v-2a8 8 0 018-8h0a8 8 0 018 8v2" />
      <path d="M24 38v-2a8 8 0 018-8h0a8 8 0 018 8v2" />
    </>
  ),
  beaker: createIcon(
    <>
      <path d="M18 6h12" />
      <path d="M20 6v12l-8 18h24l-8-18V6" />
      <path d="M16 28h16" />
    </>
  ),
  chat: createIcon(
    <>
      <path d="M12 10h24" />
      <path d="M12 24h12" />
      <path d="M12 18h16" />
      <path d="M36 18h4v22l-6-4H16a6 6 0 01-6-6V12a6 6 0 016-6h20a6 6 0 016 6v6" />
    </>
  ),
  document: createIcon(
    <>
      <path d="M30 6H18a4 4 0 00-4 4v28a4 4 0 004 4h12a4 4 0 004-4V14z" />
      <path d="M30 6v8h8" />
      <path d="M20 22h8" />
      <path d="M20 30h8" />
    </>
  ),
  mobile: createIcon(
    <>
      <rect x="16" y="6" width="16" height="36" rx="4" />
      <path d="M22 12h4" />
      <path d="M22 36h4" />
    </>
  ),
  layers: createIcon(
    <>
      <path d="M12 18l12-6 12 6-12 6z" />
      <path d="M12 30l12-6 12 6-12 6z" />
      <path d="M12 24l12-6 12 6" />
    </>
  ),
  pen: createIcon(
    <>
      <path d="M30 8l6 6L18 32l-8 2 2-8z" />
      <path d="M26 12l6 6" />
      <path d="M22 36h12" />
    </>
  ),
  code: createIcon(
    <>
      <path d="M16 16l-8 8 8 8" />
      <path d="M32 16l8 8-8 8" />
      <path d="M26 12l-4 24" />
    </>
  ),
  cloud: createIcon(
    <>
      <path d="M18 34H14a8 8 0 010-16h1a10 10 0 1119 4h2a7 7 0 010 14h-6" />
    </>
  ),
  spark: createIcon(
    <>
      <path d="M24 6l3 10h11l-9 6 3 10-8-6-8 6 3-10-9-6h11z" />
    </>
  ),
};

const fallbackIcon = icons.spark;

export const ServiceIcon = ({ name, size = 48, className = '', ...props }) => {
  const Icon = icons[name] || fallbackIcon;
  return <Icon className={className} width={size} height={size} {...props} />;
};

export const IconBadge = ({
  name,
  size = 64,
  className = '',
  backgroundOpacity = 0.16,
  ...props
}) => {
  const Icon = icons[name] || fallbackIcon;
  return (
    <span
      className={`icon-badge ${className}`.trim()}
      style={{
        '--icon-badge-size': `${size}px`,
        '--icon-badge-strength': `${Number((backgroundOpacity * 100).toFixed(1))}%`,
      }}
      aria-hidden="true"
      {...props}
    >
      <Icon className="icon-badge__svg" />
    </span>
  );
};

export const iconNames = Object.keys(icons);
